import { visualizacaoModoCalendar } from '../../../common/visualizacao-modo';

export class AtividadeVisualizacao {
    modo: number;

    constructor() {
        this.modo = visualizacaoModoCalendar.id;
    }
}
